/* OLD - DEACTIVATED BY TALITA (WILLOW)

(function () {
  function initWhatToExpectAnimation() {
    const items = document.querySelectorAll('.what-to-expect__item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.remove('is-active');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-active');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '-75% 0px -25% 0px',
        threshold: 0
      }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatToExpectAnimation);
  } else {
    initWhatToExpectAnimation();
  }
})();*/

(function () {
  function initWhatToExpectAnimation() {
    const section = document.querySelector('.what-to-expect');
    const items = document.querySelectorAll('.what-to-expect__item');

    if (!items.length || !section) return;

    function updateActiveItems() {
      const triggerPoint = window.innerHeight * 0.6;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();

        if (rect.top < triggerPoint) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    function resetItems() {
      items.forEach((item) => item.classList.remove('is-active'));
    }

    function isSectionInView() {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function handleScroll() {
      if (isSectionInView()) {
        updateActiveItems();
      } else {
        resetItems();
      }
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', handleScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatToExpectAnimation);
  } else {
    initWhatToExpectAnimation();
  }
})();